// extracted by mini-css-extract-plugin
export default {"container":"alert_container__x9VmO","header":"alert_header__7nTu3","title":"alert_title__kqFgh","icon":"alert_icon__NJk8V"};